// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__1zWPE","description":"PatientConsentPreview_description__2z8G8"};